import { FineType, IDFines, SearchBy } from "../models/fineModels";
import {
  setAccount,
  setFineType,
  setIDFines,
  setInfringement,
  setSearchedID,
} from "../store/fine/fineActions";

import { AxiosRequestConfig } from "axios";
import appConfig from "../config";
import axios from "axios";
import { getInfringementNumber } from "../utils/COCTFilter";
import handleError from "../utils/ErrorHandler";
import { setAuthLoading } from "../store/auth/authActions";
import { setInfringementToken } from "../store/fine/fineActions";
import { setNotPayableVisible } from "../store/modals/modalActions";
import store from "../store";

export const authorize = async () => {
  var data = new FormData();
  data.append("scope", appConfig.scope);
  var config = {
    method: "post",
    url: `${appConfig.baseApiUrl}/api/authorize`,
    headers: {
      Accept: "application/json",
    },
    data: data,
  };

  return axios(config)
    .then(function (response) {
      let token = response.data.token;
      if (token) store.dispatch(setInfringementToken(token));
      return {
        status: true,
        data: token,
      };
    })
    .catch(function (error) {
      return handleError(error);
    });
};

export const search = async (account: string, token = 'loggedIn', version = false) => {
  const searchBy = store.getState().fine.searchBy;
  if (searchBy === SearchBy.INFRINGEMENT_NUMBER)
    store.dispatch(setSearchedID(account.trim()));
  var data = new FormData();
  data.append("account", getInfringementNumber(account.trim()));
  if (token !== 'loggedIn') {
    data.append("token", token);
    data.append("version", JSON.stringify(version));
  }
  const authToken = store.getState().auth.token;
  var config = {
    method: "post",
    url: `${appConfig.baseApiUrl}/api/search`,
    headers: {
      Accept: "application/json",
      Authorization: `Bearer ${authToken}`,
    },
    data: data,
  };

  return axios(config)
    .then(function (response) {
      const { data } = response.data;
      const { warrantOfArrestPending } = data;
      const user = store.getState().auth.user;

      if (user && !user.is_verified && warrantOfArrestPending) {
        let url = window.location.origin;
        url += "/verify?resend_code=true";
        window.location.href = url;
        return false;
      }
      store.dispatch(setAccount(account));
      if (data && response.data.status !== "error") {
        store.dispatch(setInfringement(data));
        store.dispatch(
          setFineType(
            warrantOfArrestPending ? FineType.WARRANT : FineType.NONWARRANT
          )
        );
        return {
          status: true,
          message: "",
          data: data,
        };
      } else {
        return false;
      }
    })
    .catch(function (error) {
      if (store.getState().fine.searchBy === SearchBy.ID_NUMBER) {
        store.dispatch(setNotPayableVisible(true));
      }
      return handleError(error, "Account not found or not payable");
    });
};

export const searchByID = async (id: string, token = 'loggedIn', version = false) => {
  const idFines = store.getState().fine.idFines;
  if (idFines) store.dispatch(setAuthLoading(true));
  store.dispatch(setSearchedID(id.trim()));
  var data = new FormData();
  data.append("idnumber", id.trim());
  if (token !== 'loggedIn') {
    data.append("token", token);
    data.append("version", JSON.stringify(version));
  }
  var config = {
    method: "post",
    url: `${appConfig.baseApiUrl}/api/id-search`,
    headers: {
      Accept: "application/json",
    },
    data: data,
  };

  return axios(config)
    .then(function (response) {
      const { data } = response.data;
      const { trafficFines } = data;
      if (trafficFines && Array.isArray(trafficFines)) {
        let fines: IDFines[] = trafficFines.slice();
        fines = fines.sort((a: IDFines, b: IDFines) => {
          let aWarrant = a.warrantOfArrestPending;
          let aDate = a.dueDate;
          let bWarrant = b.warrantOfArrestPending;
          let bDate = b.dueDate;
          return (
            Number(bWarrant) - Number(aWarrant) ||
            new Date(aDate).getTime() - new Date(bDate).getTime()
          );
        });
        store.dispatch(setIDFines(fines));

        return {
          status: true,
          message: "",
          data: fines,
        };
      }

      return true;
    })
    .finally(() => {
      const idFines = store.getState().fine.idFines;
      if (idFines) store.dispatch(setAuthLoading(false));
    })
    .catch(function (error) {
      return handleError(error);
    });
};

export const getPaymentLinks = async (
  account: string,
  amount: number,
  accept_guilt: boolean,
  accept_terms: boolean
) => {
  const token = store.getState().auth.token
    ? store.getState().auth.token
    : store.getState().fine.infringementToken;

  var data = new FormData();
  data.append("account", getInfringementNumber(account.trim()));
  data.append("amount", String(amount));
  data.append("accept_guilt", String(accept_guilt));
  data.append("accept_terms", String(accept_terms));

  var config = {
    method: "post",
    url: `${appConfig.baseApiUrl}/api/initiate-payment`,
    headers: {
      Authorization: `Bearer ${token}`,
    },
    data: data,
  };

  return axios(config)
    .then(function (response) {
      const { data } = response.data;
      return {
        status: true,
        data: data,
      };
    })
    .catch(function (error) {
      return handleError(error);
    });
};

export const sendReceipt = async (account: string, email: string) => {
  const token = store.getState().auth.token
    ? store.getState().auth.token
    : store.getState().fine.infringementToken;
  var FormData = require("form-data");
  var data = new FormData();
  data.append("email", email);
  data.append("account", account);

  var config = {
    method: "post",
    url: `${appConfig.baseApiUrl}/api/receive-receipt`,
    headers: {
      Accept: "application/json",
      Authorization: `Bearer ${token}`,
    },
    data: data,
  };

  return axios(config)
    .then(function (response) {
      return {
        status: true,
      };
    })
    .catch(function (error) {
      return handleError(error);
    });
};

export const sendHandbackResponse = async (account: string, status: string) => {
  const token = store.getState().auth.token;
  const referenceKey = await localStorage.getItem("referenceKey");
  var FormData = require("form-data");
  var data = new FormData();
  data.append("account", account);
  data.append("status", status);
  data.append("referenceKey", referenceKey);

  var config = {
    method: "post",
    url: `${appConfig.baseApiUrl}/api/handback-response`,
    headers: {
      Authorization: `Bearer ${token}`,
    },
    data: data,
  };

  return axios(config)
    .then(function (response) {
      return {
        status: true,
        data: response.data.data,
      };
    })
    .catch(function (error) {
      return handleError(error);
    });
};

export const getPaymentHistory = async () => {
  const token = store.getState().auth.token;

  var data = new FormData();

  var config = {
    method: "get",
    url: `${appConfig.baseApiUrl}/api/payment-history`,
    headers: {
      Authorization: `Bearer ${token}`,
    },
    data: data,
  };

  return axios(config)
    .then(function (response) {
      return response?.data?.data;
    })
    .catch(function (error) {
      console.log(error);
      return false;
    });
};

export const downloadFile = async (account: string) => {
  const token = store.getState().auth.token;

  var FormData = require("form-data");
  var data = new FormData();
  data.append("account", account.trim());

  var config: AxiosRequestConfig = {
    method: "post",
    url: `${appConfig.baseApiUrl}/api/download-file`,
    headers: {
      Authorization: `Bearer ${token}`,
    },
    data: data,
    responseType: "blob",
  };

  return axios(config)
    .then(function (response) {
      download(response);
      return true;
    })
    .catch(function (error) {
      console.log(error);
    });
};

function download(response: any) {
  let contentDisposition: string = response.headers["content-disposition"];
  let filename = contentDisposition.slice(
    contentDisposition.indexOf("=") + 1,
    contentDisposition.length
  );
  filename = decodeURI(filename);
  const url = window.URL.createObjectURL(response.data);
  const link = document.createElement("a");
  link.target = "_blank";
  link.href = url;
  link.setAttribute("download", filename);
  document.body.appendChild(link);
  link.click();
  window.URL.revokeObjectURL(url);
  link.remove();
}
